import { getVideos } from "./videosAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    videos: [],
    isLoading: false,
    isError: false,
    error: "",
    limit: 4,
    currentPage: 1,
    totalPagination: 0,
};

// async thunk
export const fetchVideos = createAsyncThunk(
    "videos/fetchVideos",
    async ({ tags, search, author, limit, currentPage }) => {
        const videos = await getVideos(
            tags,
            search,
            author,
            limit,
            currentPage
        );
        return {
            totalLength: videos.headers["x-total-count"],
            videos: videos.data,
        };
    }
);

const videoSlice = createSlice({
    name: "videos",
    initialState,
    reducers: {
        initCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        addLimitPage: (state, action) => {
            state.limit = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVideos.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchVideos.fulfilled, (state, action) => {
                state.isLoading = false;
                state.videos = action.payload.videos;
                state.totalPagination = Math.ceil(
                    action.payload.totalLength / state.limit
                );
            })
            .addCase(fetchVideos.rejected, (state, action) => {
                state.isLoading = false;
                state.videos = [];
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export const { initCurrentPage, addLimitPage } = videoSlice.actions;
export default videoSlice.reducer;
